import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  Chip,
  MenuItem,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import dayjs from "dayjs";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";
import KPMonthYearPicker from "../../../components/KPMonthYearPicker/KPMonthYearPicker";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";

import { uploadMultiFile } from "../../../reducer/file/action";
import { updateMonograph, checkDuplicateMonograph } from "../../../reducer/monograph/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";
import DuplicateCheckModal from "../../../components/Monograph/DuplicateCheckModal";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";
import {
  getTimeResearchInformation,
  getTimeResearchInformationById,
} from "../../../reducer/timeResearchInformation/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function MonographUpdateModal(props) {
  const { updating, setUpdating } = props;
  const [disabled, setDisabled] = useState(true);

  const [values, setValues] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [fileManagerKey, setFileManagerKey] = useState(0);
  const currentYear = getCurrentSchoolYear();
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(null);

  useEffect(() => {
    if (updating) {
      resetValues();
      if (updating._fromDuplicate) {
        setDisabled(false);
      }
    }
  }, [updating]);

  useEffect(() => {
    if (updating && updating._fromDuplicate && props.profile?.id) {
      const hasCurrentUser = profileList.some((member) => member.profileId === props.profile.id);

      if (!hasCurrentUser) {
        setProfileList([
          ...profileList,
          {
            profileId: props.profile.id,
            roleInMonograph: "member",
            isInternal: true,
            externalName: "",
            timeAmount: null,
          },
        ]);
      }
    }
  }, [updating, props.profile?.id]);

  useEffect(() => {
    if (values?.profileIdForKpi >= 0) props.getTimeResearchInformation(0, timeResearchYear);
  }, [values?.profileIdForKpi, timeResearchYear]);

  useEffect(() => {
    const timeResearchDetailId = parseInt(values?.timeResearchDetailCode?.split("-").slice(0, 1).shift());
    if (timeResearchDetailId) props.getTimeResearchInformationById(timeResearchDetailId);
  }, [values?.timeResearchDetailCode]);

  // useEffect(() => {
  //   if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  // }, [values?.profileIdForKpi]);

  // console.log(timeResearchYear)

  useEffect(() => {
    if (props.employmentContractDetail)
      setValues({
        ...values,
        profileIdForKpi: props.employmentContractDetail?.profile?.id,
      });
  }, [props.employmentContractDetail]);

  useEffect(() => {
    // setDetail(props?.employmentContractListById?.find((e) => e?.contract?.id === updating?.contractIdForKpi)?.contract);
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  const resetValues = () => {
    // Format publishedDate từ DB về format "01/mm/yyyy" cho KPMonthYearPicker
    let formattedPublishedDate = updating.publishedDate;
    if (updating.publishedDate) {
      const date = new Date(updating.publishedDate);
      if (!isNaN(date.getTime())) {
        const day = "01";
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        formattedPublishedDate = `${day}/${month}/${year}`;
      }
    }

    setValues({
      ...updating,
      issueAt: dayjs(updating.issueAt).format("YYYY-MM-DD"),
      acceptedDay: dayjs(updating.acceptedDay).format("YYYY-MM-DD"),
      submissionDay: dayjs(updating.submissionDay).format("YYYY-MM-DD"),
      publishedDate: formattedPublishedDate,
      listMember: updating.listMember?.join(", "),
    });
    setProfileList([...updating.monographProfile] || []);
    setFileUrls(updating.fileUrl?.split("||").filter(Boolean) || []);
    setNewFiles([]);
    setFileManagerKey((prev) => prev + 1);
    // if (!props.isFetchingEmploymentContract) props.getEmploymentContractById(updating.contractIdForKpi);
    // setDetail(props.employmentContractListById?.find((e) => e.contract.id === updating.contractIdForKpi)?.contract);
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInMonograph: "member",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleClose = () => {
    if (!disabled) {
      resetValues();
      setDisabled(true);
    } else {
      setUpdating(null);
      setDisabled(true);
      setFileUrls([]);
      setNewFiles([]);
      setFileManagerKey((prev) => prev + 1);
    }
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
  };

  const updateMonograph = async (finalFileUrl) => {
    const tempListMember = values?.listMember?.split(",").map((author) => author.trimStart());

    // Convert publishedDate từ Date object hoặc string về ISO string
    let publishedDateToSend = values?.publishedDate;
    if (publishedDateToSend) {
      if (typeof publishedDateToSend === "string" && publishedDateToSend.includes("/")) {
        // Nếu là string format "01/mm/yyyy", convert sang Date rồi sang ISO
        const parts = publishedDateToSend.split("/");
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          publishedDateToSend = new Date(year, month - 1, day, 12, 0, 0);
        }
      }
      // Nếu là Date object, giữ nguyên để axios tự serialize
    }

    console.log("📅 Monograph Update - publishedDate:", values?.publishedDate);
    console.log("📤 Monograph Update - publishedDateToSend:", publishedDateToSend);

    let result = await props.updateMonograph(values.id, {
      ...values,
      fileUrl: finalFileUrl !== undefined ? finalFileUrl : values.fileUrl,
      publishedDate: publishedDateToSend,
      listMember: tempListMember,
      dashboardYear: values?.year,
      monographProfile: profileList,
    });
    return result;
  };

  const checkForDuplicates = async (title, currentId) => {
    if (!title || title.trim() === "") {
      return { hasDuplicates: false, data: [] };
    }

    const result = await props.checkDuplicateMonograph({
      publicationType: "monographs",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      const filteredDuplicates = result.data.filter((item) => item.monograph?.id !== currentId);

      if (filteredDuplicates.length > 0) {
        return { hasDuplicates: true, data: filteredDuplicates };
      }
    }

    return { hasDuplicates: false, data: [] };
  };

  const handleSelectDuplicate = (item) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);

    const monographToEdit = {
      ...item.monograph,
      monographProfile: item.monographProfile || [],
      _fromDuplicate: true,
    };

    setUpdating(monographToEdit);
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    if (pendingSubmit) {
      proceedWithSubmit(pendingSubmit);
      setPendingSubmit(null);
    }
  };

  const proceedWithSubmit = async (submitData) => {
    let finalFileUrl = fileUrls.join("||");
    if (newFiles.length > 0) {
      const uploadResult = await props.uploadMultiFile(values.id, newFiles, "monograph");
      if (uploadResult.success) {
        finalFileUrl = [...fileUrls, ...uploadResult.data].join("||");
      }
    }
    updateMonograph(finalFileUrl).then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
    setUpdating(null);
    setDisabled(true);
  };

  const handleSubmit = async () => {
    if (disabled) {
      setDisabled(false);
    } else {
      // check title, numOfMember, type
      if (!values?.title || !values?.numOfMember || !values?.type) {
        setHelperText(true);
        return;
      }

      // Validate at least one internal member
      const hasInternalMember = profileList.some((e) => e.isInternal === true);
      if (!hasInternalMember) {
        props.pushNoti({
          type: "warning",
          message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
        });
        return;
      }

      // const duplicateCheck = await checkForDuplicates(values?.title, values?.id);

      const submitData = {
        id: values.id,
        ...values,
        listMember: values.listMember,
        dashboardYear: values?.year,
        monographProfile: profileList,
      };

      // if (duplicateCheck.hasDuplicates) {
      //   setDuplicateList(duplicateCheck.data);
      //   setDuplicateModalOpen(true);
      //   setPendingSubmit(submitData);
      //   return;
      // }

      proceedWithSubmit(submitData);
    }
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)?.timeResearchDetail || [];

  // timeResearchDetailList = timeResearchDetailList.filter((e) => !e.allowedUpdateNum && e.type === "monograph");
  // console.log(timeResearchDetailList)

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type === "monograph");
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Phản hồi về việc khai báo thông tin Công bố khoa học",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "monograph",
      },
    });
  };

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "xl" : "lg"}
      open={updating !== null}
      onClose={handleClose}
      disableBackdropClick
    >
      <DialogTitle>
        {disabled ? "Chi tiết" : "Cập nhật"}
        {renderLockButton()}
      </DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div
          style={{
            display: "flex",
            flex: "1 1 auto",
            minWidth: 0,
            paddingRight: 16,
            alignItems: "flex-start",
          }}
        >
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={7}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                label="Tên sách/ Tiêu đề"
                variant="outlined"
                value={values?.title?.toString() || ""}
                required
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên sách/ tiêu đề" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                variant="outlined"
                label="Mã CTKH"
                value={values?.hemisCode || ""}
                onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng tác giả"
                value={values?.numOfMember || ""}
                required
                error={helperText && !values?.numOfMember}
                helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng tác giả" : ""}
                onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                size="small"
                disabled={disabled}
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                variant="outlined"
                label="Nhà xuất bản"
                value={values?.publisher || ""}
                onChange={(event) => handleChangeForm("publisher", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                disabled={disabled}
                label="Tác giả"
                variant="outlined"
                value={values?.listMember || ""}
                multiline
                rows={4}
                onChange={(event) => handleChangeForm("listMember", event.target.value)}
              />
            </Grid>
            <Grid item xs={5}>
              <KPMonthYearPicker
                fullWidth
                disabled={disabled}
                label="Tháng/Năm xuất bản"
                required
                value={values?.publishedDate || `01/01/${new Date().getFullYear()}`}
                setValue={(newValue) => {
                  console.log("🔍 Update - KPMonthYearPicker setValue called with:", newValue);
                  // newValue có dạng "01/mm/yyyy" - Lưu trực tiếp string này vào state
                  const parts = newValue.split("/");
                  if (parts.length === 3) {
                    const year = parseInt(parts[2], 10);

                    // Cập nhật CẢ publishedDate VÀ year trong một lần setState
                    console.log("✅ Update - Setting publishedDate to string:", newValue);
                    setValues({
                      ...values,
                      publishedDate: newValue,
                      year: year,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                type="number"
                label="Số trang"
                variant="outlined"
                value={values?.pageNumber || ""}
                onChange={(event) => handleChangeForm("pageNumber", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                label="Số ISBN"
                variant="outlined"
                value={values?.isbn || ""}
                onChange={(event) => handleChangeForm("isbn", event.target.value)}
              />
            </Grid>
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                type="number"
                label="Điểm GS-PGS"
                variant="outlined"
                value={values?.score || ""}
                onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
              />
            </Grid> */}
            <Grid item xs={4}>
              <FormControl fullWidth disabled={disabled} variant="outlined" size="small">
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Phân loại</InputLabel>
                <Select
                  native
                  fullWidth
                  disabled={disabled}
                  value={values?.type || ""}
                  onChange={(event) => handleChangeForm("type", event.target.value)}
                >
                  {/* <option value={null} /> */}
                  <option value="chapter">Chương sách</option>
                  <option value="monograph">Chuyên khảo</option>
                  <option value="reference">Tham khảo</option>
                  <option value="curriculum">Giáo trình</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth disabled={disabled} variant="outlined" size="small">
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Ngôn ngữ</InputLabel>
                <Select
                  native
                  fullWidth
                  disabled={disabled}
                  value={values?.language || ""}
                  onChange={(event) => handleChangeForm("language", event.target.value)}
                >
                  <option value={null} />
                  <option value="english">Tiếng Anh</option>
                  <option value="other">Khác</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  disabled={disabled}
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes
                    .filter((e) => e.name !== "bonusCalculated")
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.description}
                      </option>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            {values?.purposeId === 5 && (
              <>
                {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    disabled={disabled}
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    error={!values?.timeResearchDetailCode}
                  >
                    {timeResearchDetailList?.map((e) => (
                      <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values?.isOvertimeCountable || false}
                    disabled={
                      disabled || values?.locked === "kpi" || values?.locked === "reward" || props.role !== "sudo-admin"
                    }
                    onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                    color="primary"
                  />
                }
                label="Tính giờ ngoài quy chế"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số giờ ngoài quy chế"
                variant="outlined"
                value={values?.overtimeHours ?? ""}
                disabled={
                  disabled ||
                  values?.locked === "kpi" ||
                  values?.locked === "reward" ||
                  props.role !== "sudo-admin" ||
                  !values?.isOvertimeCountable
                }
                onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                inputProps={{
                  min: 0,
                  step: 0.1,
                }}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          disabled={disabled}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <Autocomplete
                        disableClearable
                        disabled={disabled}
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={props.profileList?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) =>
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id))
                        }
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={disabled}
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 3 : 1}>
                    <FormControl fullWidth disabled={disabled} variant="outlined" size="small">
                      <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Vai trò</InputLabel>
                      <Select
                        native
                        fullWidth
                        value={e?.roleInMonograph || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInMonograph", event.target.value)}
                      >
                        <option value="main">Chủ biên</option>
                        <option value="member">Đồng tác giả</option>
                        {/* <option value="mainOther">Chủ biên tính hộ</option>
                        <option value="memberOther">Đồng tác giả tính hộ</option> */}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 2 : 2}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      disabled={disabled}
                      variant="outlined"
                      label="Số giờ"
                      value={e?.timeAmount || ""}
                      onChange={(event) =>
                        handleChangeProfileList(index, "timeAmount", parseFloat(event.target.value) || null)
                      }
                    />
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          disabled={disabled}
                          style={{ height: 40 }}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          disabled={disabled}
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flexDirection: "column",
            display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
          }}
        >
          <EmploymentContractTable
            contract={detail}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            values={values}
            setValues={setValues}
            handleChangeForm={handleChangeForm}
          />
          <EmploymentContractDetailTable kpi={detail} />
        </div>
        <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600 }}>
            File minh chứng
          </Typography>
          <MultiFileManager
            key={fileManagerKey}
            fileUrls={fileUrls}
            setFileUrls={setFileUrls}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={disabled}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div>
            {props.adminTab && (
              <Button variant="outlined" onClick={handleSendFeedback}>
                Gửi feedback
              </Button>
            )}
            <Button variant="outlined" color="secondary" onClick={handleClose} style={{ margin: "0 4px" }}>
              Huỷ
            </Button>
            <Tooltip
              disableHoverListener={props.role === "sudo-admin"}
              title="Liên hệ phòng KHCN để đề xuất chỉnh sửa CTKH"
            >
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={
                    (!disabled &&
                      ((values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                        (values?.purposeId === 99999999 && !values?.profileIdForReward) ||
                        (values?.purposeId === 5 && !values?.timeResearchDetailCode))) ||
                    values?.locked ||
                    (values?.accepted && props.role !== "sudo-admin")
                  }
                >
                  {disabled ? "Chỉnh sửa" : "Xác nhận"}
                </Button>
              </span>
            </Tooltip>
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        onClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  updateMonograph: (id, payload) => dispatch(updateMonograph(id, payload)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getTimeResearchInformationById: (id) => dispatch(getTimeResearchInformationById(id)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  getTimeResearchInformation: (profileId, year) => dispatch(getTimeResearchInformation(profileId, year)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
  checkDuplicateMonograph: (payload) => dispatch(checkDuplicateMonograph(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(MonographUpdateModal));

